import ZlbConfirm from '@/components/ZlbConfirm';
import {
  exportDeptIndicatorsList,
  exportIndicatorsList,
  fetchBudgetIndicatorsList,
  fetchDepartmentIndicatorsList,
  getExportDeptResult,
  getExportResult,
  importIndicatorSubmit,
  reqBudgetDetail,
  reqSyncBudgetInfo,
} from '../services';

const responseErrorHandle = res => {
  const { success, message } = res;
  if (!success) {
    ZlbConfirm({
      title: message,
      showOkBtn: false,
      cancelText: '知道了',
    });
  }
  return success;
};

export default {
  namespace: 'budgetIndicators',
  state: {
    detail: {},
  },
  effects: {
    /**
     * 同步预算指标
     */
    *updateBudgetInfo({ payload }, { call }) {
      return yield call(reqSyncBudgetInfo, payload);
    },

    /**
     * 预算指标列表
     */
    *getBudgetIndicatorsList({ payload }, { call }) {
      const res = yield call(fetchBudgetIndicatorsList, payload);
      responseErrorHandle(res);
      return res;
    },

    /**
     * 预算指标详情
     */
    *getBudgetDetail({ payload }, { call, put }) {
      const res = yield call(reqBudgetDetail, payload);
      responseErrorHandle(res);
      yield put({
        type: 'update',
        payload: {
          detail: res.result || [],
        },
      });
      return res;
    },

    /**
     * 查询部门指标或者单位指标
     */
    *getDepartmentIndicatorsList({ payload }, { call }) {
      const res = yield call(fetchDepartmentIndicatorsList, payload);
      responseErrorHandle(res);
      return res;
    },

    /**
     * 导出预算指标列表
     */
    *exportIndicatorsList({ payload }, { call }) {
      const res = yield call(exportIndicatorsList, payload);
      return res;
    },
    /**
     * 最新获取导出结果
     */
    *getExportResult({ payload }, { call }) {
      const res = yield call(getExportResult, payload);
      return res;
    },
    /**
     * 导出预算指标列表
     */
    *exportDeptIndicatorsList({ payload }, { call }) {
      const res = yield call(exportDeptIndicatorsList, payload);
      return res;
    },
    /**
     * 最新获取导出结果
     */
    *getExportDeptResult({ payload }, { call }) {
      const res = yield call(getExportDeptResult, payload);
      return res;
    },

    // 预算指标导入实施金额
    *importIndicatorSubmit({ payload }, { call }) {
      const res = yield call(importIndicatorSubmit, payload);
      return res;
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
